import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  CreateSupportTicketPayload,
  RequestResponse,
  SupportTicket,
  UpdateSupportTicketPayload,
} from '@/types';

export const createSupportTicket = async (
  payload: CreateSupportTicketPayload
) => {
  const response = await axiosInstance.post<RequestResponse<SupportTicket>>(
    endpoints.support.tickets,
    payload
  );
  return response.data.data;
};

export const updateSupportTicket = async ({
  uuid,
  payload,
}: {
  uuid: number | string;
  payload: UpdateSupportTicketPayload;
}) => {
  const response = await axiosInstance.patch<RequestResponse<SupportTicket>>(
    `${endpoints.support.tickets}/${uuid}`,
    payload
  );
  return response.data.data;
};

export const deleteSupportTicket = async (uuid: number | string) => {
  const response = await axiosInstance.delete<RequestResponse<null>>(
    `${endpoints.support.tickets}/${uuid}`
  );
  return response.data.data;
};
